<template>
  <div>
    <el-row class="team-build-row">
      <el-col :span="6" :offset="1">
        <h1>交叉路口</h1>
      </el-col>
    </el-row>
    <el-row class="team-build-row">
      <el-col :span="20" :offset="2">
        <el-tabs v-model="activeTab" @tab-click="onTab" size="small">
          <el-tab-pane label="新增交叉路口" name="first">
            <el-row class="team-build-row">
              <el-col :span="6">
                <el-select
                  v-model="city"
                  placeholder="選擇都市"
                  @change="onCity"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CITIES"
                    :label="item.name"
                    :key="item.num"
                    :value="item.name"
                  />
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-select
                  v-model="region"
                  placeholder="選擇地區"
                  @change="onRegion"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in regionOptions"
                    :label="item.name"
                    :key="item.num"
                    :value="item.name"
                  />
                </el-select>
              </el-col>
            </el-row>
            <el-row class="team-build-row">
              <el-col :span="6">
                <el-input
                  placeholder="輸入路名1"
                  v-model="inputRoad1"
                  clearable
                  size="small"
                />
              </el-col>
              <el-col :span="6">
                <el-input
                  placeholder="輸入路名2"
                  v-model="inputRoad2"
                  clearable
                  size="small"
                />
              </el-col>
            </el-row>
            <el-row class="team-build-row">
              <el-col :span="6">
                <el-input
                  placeholder="緯度"
                  v-model="latitude"
                  clearable
                  size="small"
                />
              </el-col>
              <el-col :span="6">
                <el-input
                  placeholder="經度"
                  v-model="longitude"
                  clearable
                  size="small"
                />
              </el-col>
              <el-col :span="3">
                <el-button
                  type="primary"
                  @click="addIntersection"
                  :loading="isAddBtnLoading"
                  size="medium"
                >
                  新增
                </el-button>
              </el-col>
            </el-row>
            <el-row class="team-build-row">
              <el-col :span="12">
                <div class="addr-complete-wrapper">
                  <AddrAutoComplete
                    v-model="inputAddr"
                    @getSelectedAddr="getSelectedAddr"
                    style="width: 100%"
                  />
                </div>
              </el-col>
              <el-col :span="3" align="left">
                <el-button type="info" @click="setLineMarker" size="medium">
                  設定座標
                </el-button>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="檢視交叉路口" name="second">
            <el-row class="team-build-row">
              <el-col :span="3">
                <el-select v-model="npp" @change="onNpp">
                  <el-option
                    v-for="npp in [10, 25, 50, 100]"
                    :key="npp"
                    :label="npp"
                    :value="npp"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="10" style="display: flex">
                <h4 style="margin-right: 10px">搜尋交叉路口:</h4>
                <el-input
                  v-model="search"
                  placeholder="搜尋交叉路口"
                  style="flex: 1"
                  @keyup.enter.native="searchIntersection"
                />
                <el-button
                  type="primary"
                  @click="searchIntersection"
                  :loading="isSearchLoading"
                  style="margin-left: 10px"
                >
                  查詢
                </el-button>
                <el-button @click="resetSearch" style="margin-left: 10px">
                  重設
                </el-button>
              </el-col>
              <el-col :span="10" style="margin-top: 15px; text-align: center">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-size="npp"
                  :total="tableData.length"
                  layout="prev, pager, next, jumper, total"
                ></el-pagination>
              </el-col>
            </el-row>
            <el-row>
              <div
                v-loading="isSearchLoading"
                element-loading-text="搜尋中..."
                style="width: 100%; position: relative; min-height: 515px"
              >
                <IntersectionTable
                  :tableData="paginatedTableData"
                  @selectEditIntersection="selectEditIntersection"
                />
              </div>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="編輯交叉路口" name="third" v-if="isShowEdit">
            <el-row class="team-build-row">
              <el-col :span="6">
                <el-select
                  v-model="city"
                  placeholder="選擇都市"
                  @change="onCity"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CITIES"
                    :label="item.name"
                    :key="item.num"
                    :value="item.name"
                  />
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-select
                  v-model="region"
                  placeholder="選擇地區"
                  @change="onRegion"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in regionOptions"
                    :label="item.name"
                    :key="item.num"
                    :value="item.name"
                  />
                </el-select>
              </el-col>
            </el-row>
            <el-row class="team-build-row">
              <el-col :span="6">
                <el-input
                  placeholder="輸入路名1"
                  v-model="inputRoad1"
                  clearable
                  size="small"
                />
              </el-col>
              <el-col :span="6">
                <el-input
                  placeholder="輸入路名2"
                  v-model="inputRoad2"
                  clearable
                  size="small"
                />
              </el-col>
            </el-row>
            <el-row class="team-build-row">
              <el-col :span="6">
                <el-input
                  placeholder="緯度"
                  v-model="latitude"
                  clearable
                  size="small"
                />
              </el-col>
              <el-col :span="6">
                <el-input
                  placeholder="經度"
                  v-model="longitude"
                  clearable
                  size="small"
                />
              </el-col>
              <el-col :span="4">
                <el-button
                  type="primary"
                  @click="editIntersection"
                  :loading="isAddBtnLoading"
                  size="medium"
                >
                  修改
                </el-button>
                <el-button
                  type="danger"
                  @click="removeIntersection"
                  size="medium"
                >
                  刪除
                </el-button>
              </el-col>
            </el-row>

            <el-row class="team-build-row">
              <el-col :span="12">
                <div class="addr-complete-wrapper">
                  <AddrAutoComplete
                    v-model="inputAddr"
                    @getSelectedAddr="getSelectedAddr"
                    style="width: 100%"
                  />
                </div>
              </el-col>
              <el-col :span="3" align="left">
                <el-button type="info" @click="setLineMarker" size="medium">
                  設定座標
                </el-button>
              </el-col>
            </el-row>

            <el-row class="team-build-row">
              <el-col :span="12" style="margin-right: 20px">
                <span style="font-size: 20px">
                  最後編輯日期: {{ formatDate(lastUpdateTime) }}
                  <span>
                    {{ lastUpdater }}
                  </span>
                </span>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <el-row class="team-build-row">
      <el-col :span="18" :offset="2">
        <google-map
          name="example"
          ref="mapMarker"
          style="height: 400px"
          :input-latitude="searchLocation.latitude"
          :input-longitude="searchLocation.longitude"
          :size="10"
          v-if="isShowMap"
          @deliveryGPSData="listenGPSFromMap"
          @mapReady="handleMapReady"
        />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  reqIntersectionList,
  reqAddIntersection,
  reqUpdateIntersection,
  reqDeleteIntersection,
} from '@/api/teamBuildLocation'
import { cookies } from '@/utils/cookies'
import { cities, tainan, kaohsiung } from '@/constants/teamBuildLocation'
import { Notification } from 'element-ui'
import AddrAutoComplete from '@/components/tool/AddrAutoComplete'
import GoogleMap from '../mapComponent/LandmarkMap.vue'
import IntersectionTable from './IntersectionTable'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import dayjs from 'dayjs'

export default {
  components: {
    GoogleMap,
    IntersectionTable,
    AddrAutoComplete,
  },
  data() {
    return {
      tableData: [],
      originalTableData: [], // 保存從 API 獲取的完整原始資料
      activeTab: 'first',
      latitude: '',
      longitude: '',
      city: '',
      cityNumber: 0,
      region: '',
      regionNumber: 0,
      inputAddr: '',
      searchLocation: {
        latitude: null,
        longitude: null,
        address: null,
      },
      autoLocation: {
        latitude: null,
        longitude: null,
        address: null,
      },
      inputRoad1: '',
      inputRoad2: '',
      markerInfo: {
        address: '',
        latGps: '',
        lngGps: '',
      },
      isAddBtnLoading: false,
      isSearchLoading: false, // 搜尋按鈕的 loading 狀態
      npp: 25,
      currentPage: 1,
      paginatedTableData: [],
      search: '',
      isShowEdit: false,
      isShowMap: true,
      currentSelectedData: null,
      currentEditIntersectionID: '',
      lastUpdateTime: '---',
      lastUpdater: '---',
      isMapReady: false,
    }
  },
  methods: {
    setLineMarker() {
      if (!this.autoLocation.latitude || !this.autoLocation.longitude) {
        this.$notify({
          title: '警告',
          message: '無效的座標資料，請先選擇一個有效地址',
          type: 'warning',
        })
        return
      }

      const lat = parseFloat(this.autoLocation.latitude)
      const lng = parseFloat(this.autoLocation.longitude)

      if (isNaN(lat) || isNaN(lng)) {
        this.$notify({
          title: '警告',
          message: '座標格式無效，請確保輸入的是有效數字',
          type: 'warning',
        })
        return
      }

      this.latitude = lat
      this.longitude = lng

      this.$refs.mapMarker.setDrawMarker({
        lat: lat,
        lng: lng,
      })
    },
    setLocationMarker(row) {
      this.$refs.mapMarker.setMarker({
        lat: row.intersectionGps.coordinates[1],
        lng: row.intersectionGps.coordinates[0],
      })
    },
    listenGPSFromMap(m) {
      this.markerInfo.address = m.formatted_address
      this.markerInfo.latGps = m.geometry.location.lat()
      this.markerInfo.lngGps = m.geometry.location.lng()
      this.latitude = m.geometry.location.lat()
      this.longitude = m.geometry.location.lng()
    },
    onTab(tab) {
      if (tab.name === 'second') {
        this.getIntersectionList()
        this.isShowEdit = false
        this.isShowMap = false
      } else if (tab.name === 'first') {
        this.isShowEdit = false
        this.isShowMap = true
      }
    },
    onCity(selectedCityName) {
      const targetCity = this.CITIES.find(
        ({ name }) => name === selectedCityName,
      )
      if (targetCity) {
        this.cityNumber = targetCity.countyNumber
        this.region = ''
      } else {
        throw new Error('找尋不到選擇的城市資訊')
      }
    },
    onRegion(selectedRegionName) {
      let regionOptions = null
      if (this.city === '高雄市') {
        regionOptions = this.KAO
      } else if (this.city === '台南市') {
        regionOptions = this.TAINAN
      }
      const targetRegion = regionOptions.find(
        ({ name }) => name === selectedRegionName,
      )
      if (targetRegion) {
        this.regionNumber = targetRegion.num
      } else {
        throw new Error('找尋不到選擇的區域資訊')
      }
    },
    getSelectedAddr({ longitude, latitude }) {
      this.autoLocation = {
        longitude: longitude,
        latitude: latitude,
        address: this.inputAddr,
      }
    },
    async addIntersection() {
      /* 表單校驗 */
      if (!this.latitude || !this.longitude) {
        Notification({ type: 'warning', message: '請輸入經緯度' })
        return
      }
      if (!this.inputRoad1) {
        Notification({ type: 'warning', message: '請輸入路名1' })
        return
      }
      if (!this.inputRoad2) {
        Notification({ type: 'warning', message: '請輸入路名2' })
        return
      }
      if (!this.city) {
        Notification({ type: 'warning', message: '請選擇城市' })
        return
      }
      if (!this.region) {
        Notification({ type: 'warning', message: '請選擇地區' })
        return
      }
      try {
        this.isAddBtnLoading = true
        BehaviorRecorder.record(
          '點擊',
          '交叉路口',
          `新建自建交叉路口, ${this.inputRoad1}與${this.inputRoad2}, ${this.latitude}, ${this.longitude}`,
        )
        const { result } = await reqAddIntersection({
          countyNumber: this.cityNumber,
          countyName: this.city,
          townNumber: this.regionNumber,
          townName: this.region || null,
          roadName: this.inputRoad1,
          intersectionName: this.inputRoad2,
          searchData: this.inputRoad1 + '與' + this.inputRoad2,
          longitude: this.longitude,
          latitude: this.latitude,
        })
        if (result) {
          Notification({ type: 'success', message: '新增交叉路口成功' })
          this.initFormData()
        } else {
          Notification({ type: 'error', message: '新增交叉路口失敗' })
        }
      } catch (e) {
        Notification({ type: 'error', message: '新增交叉路口失敗' })
        console.error(e)
      } finally {
        this.isAddBtnLoading = false
      }
    },
    async removeIntersection() {
      const deleteIntersectionID = this.currentEditIntersectionID
      if (!deleteIntersectionID) {
        Notification({ type: 'error', message: '刪除交叉路口失敗' })
        console.error('沒有取得currentEditIntersectionID')
        return
      }

      if (!confirm('確定要刪除嗎？')) {
        return
      }

      try {
        if (this.currentSelectedData) {
          BehaviorRecorder.record(
            '點擊',
            '交叉路口',
            `刪除交叉路口, ${this.currentSelectedData.roadName}與${this.currentSelectedData.intersectionName}`,
          )
        } else {
          BehaviorRecorder.record(
            '點擊',
            '交叉路口',
            `刪除交叉路口, ID: ${deleteIntersectionID}`,
          )
        }

        const { success } = await reqDeleteIntersection(deleteIntersectionID)
        if (success) {
          Notification({ type: 'success', message: '移除交叉路口成功' })
          this.currentEditIntersectionID = '' // 清空 ID
          this.currentSelectedData = null // 清空選擇的資料
          this.isShowEdit = false // 隱藏編輯頁籤
          this.activeTab = 'second' // 回到檢視頁籤
          this.getIntersectionList()
        } else {
          Notification({ type: 'error', message: '移除交叉路口失敗' })
        }
      } catch (e) {
        Notification({ type: 'error', message: '移除交叉路口失敗' })
        console.error(e)
      }
    },
    async editIntersection() {
      /* 表單校驗 */
      if (!this.latitude || !this.longitude) {
        Notification({ type: 'warning', message: '請輸入經緯度' })
        return
      }
      if (!this.inputRoad1) {
        Notification({ type: 'warning', message: '請輸入路名1' })
        return
      }
      if (!this.inputRoad2) {
        Notification({ type: 'warning', message: '請輸入路名2' })
        return
      }
      if (!this.city) {
        Notification({ type: 'warning', message: '請選擇城市' })
        return
      }
      if (!this.region) {
        Notification({ type: 'warning', message: '請選擇地區' })
        return
      }

      try {
        this.isAddBtnLoading = true

        const note = `編輯交叉路口, ${this.inputRoad1}與${this.inputRoad2}, ${this.latitude}, ${this.longitude}`
        // 記錄編輯行為
        BehaviorRecorder.record('點擊', '交叉路口', note)
        const result = await reqUpdateIntersection({
          id: this.currentEditIntersectionID,
          countyNumber: this.cityNumber,
          countyName: this.city,
          townNumber: this.regionNumber,
          townName: this.region || null,
          roadName: this.inputRoad1,
          intersectionName: this.inputRoad2,
          searchData: this.inputRoad1 + '與' + this.inputRoad2,
          longitude: this.longitude,
          latitude: this.latitude,
        })

        if (result) {
          Notification({ type: 'success', message: '編輯交叉路口成功' })
          this.getIntersectionList() // 重新載入列表
          this.activeTab = 'second' // 切回檢視頁籤
          this.isShowEdit = false
        } else {
          Notification({ type: 'error', message: '編輯交叉路口失敗' })
        }
      } catch (e) {
        Notification({ type: 'error', message: '編輯交叉路口失敗' })
        console.error(e)
      } finally {
        this.isAddBtnLoading = false
      }
    },
    async getIntersectionList(skipSearch = false) {
      try {
        const { result, success } = await reqIntersectionList()
        if (success) {
          // 同時更新原始資料和顯示資料
          this.originalTableData = result
          this.tableData = result
          // 如果有搜尋條件且不是從 searchIntersection 調用的，重新執行搜尋
          if (!skipSearch && this.search && this.search.trim() !== '') {
            this.searchIntersection()
          } else {
            this.fetchIntersectionData()
          }
        } else {
          Notification({ type: 'error', message: '提取交叉路口列表失敗' })
        }
      } catch (e) {
        Notification({ type: 'error', message: '提取交叉路口列表失敗' })
        console.error(e)
      } finally {
      }
    },
    initFormData() {
      this.city = ''
      this.region = ''
      this.inputRoad1 = ''
      this.inputRoad2 = ''
      this.longitude = ''
      this.latitude = ''
    },
    onNpp() {
      this.currentPage = 1
      this.fetchIntersectionData()
    },
    fetchIntersectionData() {
      const startIndex = (this.currentPage - 1) * this.npp
      const endIndex = startIndex + this.npp

      // 從當前 tableData（可能已篩選）進行分頁
      this.paginatedTableData = this.tableData.slice(startIndex, endIndex)
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchIntersectionData()
    },
    /**
     * 確保 loading 至少持續指定的最小時間
     * @param {number} startTime - 開始時間戳
     * @param {number} minTime - 最小持續時間（毫秒），預設 500ms
     */
    async ensureMinLoadingTime(startTime, minTime = 500) {
      const elapsedTime = Date.now() - startTime
      if (elapsedTime < minTime) {
        await new Promise((resolve) =>
          setTimeout(resolve, minTime - elapsedTime),
        )
      }
    },
    async searchIntersection() {
      const startTime = Date.now()
      const minLoadingTime = 500 // 最小 loading 時間（毫秒）

      try {
        this.isSearchLoading = true

        if (!this.search || this.search.trim() === '') {
          // 若搜尋條件為空，從原始資料恢復顯示所有資料
          this.tableData = [...this.originalTableData]
          this.currentPage = 1
          this.fetchIntersectionData()
          await this.ensureMinLoadingTime(startTime, minLoadingTime)
          return
        }

        // 確保有原始資料可以搜尋
        if (!this.originalTableData || this.originalTableData.length === 0) {
          // 如果沒有原始資料，先獲取資料（傳入 skipSearch=true 避免重複調用）
          await this.getIntersectionList(true)
        }

        const keyword = this.search.toLowerCase().trim()
        // 從原始資料進行篩選，符合roadName或intersectionName包含關鍵字的資料
        const filteredData = this.originalTableData.filter((item) => {
          const roadName = (item.roadName || '').toLowerCase()
          const intersectionName = (item.intersectionName || '').toLowerCase()
          return (
            roadName.includes(keyword) || intersectionName.includes(keyword)
          )
        })

        // 更新過濾後的資料（不覆蓋原始資料）
        this.tableData = filteredData
        this.currentPage = 1
        this.fetchIntersectionData()

        if (filteredData.length === 0) {
          this.$notify({
            title: '搜尋結果',
            message: '沒有找到符合條件的交叉路口',
            type: 'info',
          })
        }

        await this.ensureMinLoadingTime(startTime, minLoadingTime)
      } catch (e) {
        console.error('搜尋過程中發生錯誤:', e)
        Notification({ type: 'error', message: '搜尋失敗，請稍後再試' })
        await this.ensureMinLoadingTime(startTime, minLoadingTime)
      } finally {
        this.isSearchLoading = false
      }
    },
    resetSearch() {
      this.search = ''
      // 從原始資料恢復顯示所有資料
      this.tableData = [...this.originalTableData]
      this.currentPage = 1
      this.fetchIntersectionData()
    },
    selectEditIntersection(row) {
      this.isShowEdit = true
      this.isShowMap = true
      this.activeTab = 'third'
      this.currentEditIntersectionID = row.id

      // 從原始資料中查找，確保能找到完整的資料
      const selectedRow =
        this.originalTableData.find((item) => item.id === row.id) ||
        this.tableData.find((item) => item.id === row.id)

      if (selectedRow) {
        this.currentSelectedData = selectedRow

        this.city = selectedRow.countyName || ''
        this.region = selectedRow.townName || ''
        this.inputRoad1 = selectedRow.roadName || ''
        this.inputRoad2 = selectedRow.intersectionName || ''
        this.lastUpdateTime = selectedRow.updatedAt || '---'
        this.lastUpdater = selectedRow.teamManagerName || '---'

        if (
          selectedRow.intersectionGps &&
          selectedRow.intersectionGps.coordinates &&
          Array.isArray(selectedRow.intersectionGps.coordinates)
        ) {
          this.longitude = String(
            selectedRow.intersectionGps.coordinates[0] || '',
          )
          this.latitude = String(
            selectedRow.intersectionGps.coordinates[1] || '',
          )
        } else {
          console.warn('座標資料結構不完整或格式不正確')
          return
        }

        // 等待地圖準備就緒後再設置標記
        this.$nextTick(() => {
          if (this.$refs.mapMarker && this.$refs.mapMarker.map) {
            this.setLocationMarker(selectedRow)
            const centerValue = {
              lat: parseFloat(this.latitude),
              lng: parseFloat(this.longitude),
              zoom: 16,
            }
            this.$refs.mapMarker.moveZoom(centerValue)
          } else {
            console.warn('地圖元件尚未準備就緒')
          }
        })
      }
    },
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    },
    setDefaultCity() {
      const areaName = cookies.get('GladArea')
      const validCities = ['高雄市', '台南市']
      this.city = validCities.includes(areaName) ? areaName : '台南市'
      this.onCity(this.city)
    },
    handleMapReady() {
      this.isMapReady = true
      // 如果有正在編輯的資料，重新設置標記
      if (this.currentSelectedData) {
        this.setLocationMarker(this.currentSelectedData)
        const centerValue = {
          lat: parseFloat(this.latitude),
          lng: parseFloat(this.longitude),
          zoom: 16,
        }
        this.$refs.mapMarker.moveZoom(centerValue)
      }
    },
  },
  computed: {
    regionOptions() {
      if (this.city === '高雄市') {
        return this.KAO
      } else if (this.city === '台南市') {
        return this.TAINAN
      }
      return []
    },
    totalPages() {
      return Math.ceil(this.tableData.length / this.npp)
    },
  },
  watch: {
    tableData: {
      handler() {
        this.fetchIntersectionData()
      },
      deep: true,
    },
  },
  mounted() {
    this.inputAddr = cookies.get('GladArea')
    this.fetchIntersectionData()
  },
  created() {
    this.CITIES = cities
    this.TAINAN = tainan
    this.KAO = kaohsiung
    this.setDefaultCity()
  },
}
</script>
<style scoped>
.team-build-row {
  margin-bottom: 10px;
}

.addr-complete-wrapper {
  position: relative;
}

.addr-complete-wrapper >>> .customerAutoComplete__listContainer {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 2000;
}

.addr-complete-wrapper >>> .customerAutoComplete__list {
  max-height: 200px;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-tabs >>> .el-tabs__content {
  overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/pages/teamBuildLocation/TeamBuildLocation.vue